import React from 'react'
import SearchEngineWithProviders from '../../Search Engine'

const VirConsultWraper = () => {
  console.log('🚨 VirConsultWraper LOADED - Version 4.0 - SEARCH ENGINE WITH TYPE SELECTOR')
  console.log('🚨 Using SearchEngineWithProviders with isVirtualVisit=true')

  return <SearchEngineWithProviders isVirtualVisit={true} />
}

export default VirConsultWraper
